import { render, staticRenderFns } from "./editMainPage.vue?vue&type=template&id=4314c6a6&scoped=true"
import script from "./editMainPage.vue?vue&type=script&lang=js"
export * from "./editMainPage.vue?vue&type=script&lang=js"
import style0 from "./editMainPage.vue?vue&type=style&index=0&id=4314c6a6&prod&lang=scss"
import style1 from "./editMainPage.vue?vue&type=style&index=1&id=4314c6a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4314c6a6",
  null
  
)

export default component.exports